// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 328 ? "admin" : chunkId) + "." + {"35":"08502932","328":"f4dfa6cc","485":"03b94ba5"}[chunkId] + ".js";
};